/** Сравнение пропсов строки и ячейки для `memo`: Row TanStack пересоздаётся вместе с моделью строк (подгрузка,
 *  сортировка, раскрытие), поэтому строка сравнивается по своим данным, остальное — по ссылке. */
export function samePropsByRowData<P extends { row: { id: string; original: unknown } }>(prev: P, next: P): boolean {
    for (const key in next) {
        if (key !== 'row' && !Object.is(prev[key], next[key])) return false;
    }
    return prev.row.id === next.row.id && prev.row.original === next.row.original;
}
